import { atom } from 'recoil';
const initialState = {
    sub: 0,
    username: '',
    email: '',
    nickName: '',
    roles: [], // 역할 이름만 포함
}
export const userState = atom({
    key: 'userState',
    default: initialState, // 로그인 전은 null, 로그인 성공 후 userInfo 객체로 갱신
});